import type { ButtonProps } from "antd";

import { Button } from "antd";
import { forwardRef } from "react";

/**
 * BasicButton: A high-order component wrapper for Ant Design Button.
 * We use 'any' or a union type for the ref to match Ant Design's internal Button requirements.
 */
export const BasicButton = forwardRef<HTMLElement, ButtonProps>((props, ref) => {
	const { children, type = "primary", ...rest } = props;

	return (
		<Button
			// We cast the ref to any or the specific internal type to resolve the compatibility issue
			ref={ref as any}
			type={type}
			{...rest}
		>
			{children}
		</Button>
	);
});

BasicButton.displayName = "BasicButton";
